<template>
	<v-app>
		<alert-component />
		<error-overlay />
		<loading-overlay />

		<authenticated-context v-if="isAuthenticated" />
		<unauthenticated-context v-else />
	</v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import { AuthGetterTypes } from '@/store/getters';
import { AuthActionTypes } from '@/store/actions';
import LoadingOverlay from '@/components/layout/LoadingOverlay';

import AlertComponent from '@/components/core/AlertComponent';
import ErrorOverlay from './components/layout/ErrorOverlay.vue';
import AuthenticatedContext from './components/AuthenticatedContext.vue';
import UnauthenticatedContext from './components/UnauthenticatedContext.vue';

export default {
	name: 'App',
	components: {
		AlertComponent,
		LoadingOverlay,
		ErrorOverlay,
		AuthenticatedContext,
		UnauthenticatedContext,
	},
	computed: {
		...mapGetters({
			isAuthenticated: [AuthGetterTypes.IS_AUTHENTICATED],
		}),
	},
	mounted() {
		if (!this.isAuthenticated) {
			this.$store.dispatch(AuthActionTypes.LOGOUT);
			this.$router.push('/login');
		}
	},
};
</script>
